/* eslint-disable @nx/enforce-module-boundaries */
import { Component, DestroyRef, ElementRef, OnChanges, OnInit, SimpleChanges, ViewChild, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { ImageInputComponent } from 'admin-drivers/src/app/common/components/image-input/image-input.component';
import { delay, take, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BaseDialogStepperFormComponent } from 'admin-drivers/src/app/common/dialog/base-dialog-stepper-form';
import { LicenseCategory } from 'admin-drivers/src/app/common/models/LicenseCategory';
import { LicenseCategoryService } from 'admin-drivers/src/app/api/services/license-category.service';

@Component({
  selector: 't-llevo-license-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    ImageInputComponent,
  ],
  templateUrl: './license-form.component.html',
  styles: `
    @import '../../../../utils/styles/formGroup.scss';
    form {
      & > mat-form-field:nth-child(-n + 4) {
        display: flex;
        width: 49%;
      }

      & > t-llevo-image-input {
        width: 100%;
        min-height: 200px;
        max-height: 350px;
      }
    }
  `,
})
export class LicenseFormComponent extends BaseDialogStepperFormComponent<FormGroup> implements OnInit, OnChanges{
  protected maxApprovedDate = new Date();
  protected minExpirationDate = new Date();
  protected licenseCategories: LicenseCategory[] = [];

  private licenseCatSrv = inject(LicenseCategoryService);
  private destroyRef = inject(DestroyRef);

  @ViewChild('firstInput') elementRef!: ElementRef<HTMLInputElement>

  ngOnInit(): void {
    this.loaderId = this.loaderSrv.subscribe();
    this.licenseCatSrv.categories$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .pipe(
        tap(() => {
          this.loaderSrv.show(this.loaderId);
        }),  
        delay(100)
      )
      .subscribe({
        next: (data) => {
          if (data) {
            this.licenseCategories = data;
            this.loaderSrv.hide(this.loaderId);
          } else {
            this.licenseCatSrv.getCategories().pipe(take(1)).subscribe();
          }
        },
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['focusOnFirstInput'] && this.focusOnFirstInput && this.loaderSrv.updatedCount > 0){
      setTimeout(()=>{this.elementRef.nativeElement.focus()}, 100)
    }
  }

  get categories() {
    return this.frm.controls['categories'];
  }

  get licenseNumber() {
    return this.frm.controls['licenseNumber'];
  }

  get expeditionDate() {
    return this.frm.controls['expeditionDate'];
  }

  get expiredYear() {
    return this.frm.controls['expiredYear'];
  }

  get image() {
    return this.frm.controls['image'] as FormControl<File | null>;
  }
}
